import React from 'react';
import { useTheme } from '@mui/material';
import { IconButton, Tooltip } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';

const ToggleColorMode = ({ colorMode }) => {
    const theme = useTheme();
    return (
        <IconButton
            sx={{
                ml: 1,
            }}
            onClick={colorMode.toggleColorMode}
            color='inherit'
        >
            {theme.palette.mode === 'dark' ? (
                <Tooltip title='Passer en mode clair'>
                    <Brightness7 />
                </Tooltip>
            ) : (
                <Tooltip title='Passer en mode sombre'>
                    <Brightness4 />
                </Tooltip>
            )}
        </IconButton>
    );
};

export default ToggleColorMode;
